<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-券-修改
    -->
  <el-dialog
      title="修改券"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
  >

    <div class="product-add pb50">

      <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">

        <el-form-item label="券名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入券名称" class="max-w460"></el-input>
        </el-form-item>
        
        <!-- 添加：单价和单位 -->
        <el-form-item label="单价" prop="unit_price">
          <div class="price-input-wrapper">
            <el-input 
              v-model="form.unit_price" 
              placeholder="请输入券单价" 
              class="max-w300"
              style="margin-right: 10px;"
            ></el-input>
            <el-select 
              v-model="form.unit_price_unit" 
              placeholder="选择单位"
              style="width: 130px;"
              clearable
            >
              <el-option label="元/人次" :value="0"></el-option>
              <el-option label="元/学时" :value="1"></el-option>
              <el-option label="元/课时" :value="2"></el-option>
            </el-select>
          </div>
        </el-form-item>
        
        <!-- 添加：面额 -->
        <el-form-item label="面额" prop="denomination">
          <el-input v-model="form.denomination" placeholder="请输入券面额" class="max-w460"></el-input>
        </el-form-item>
        
        <!-- 添加：数量 -->
        <el-form-item label="数量" prop="num">
          <el-input v-model="form.num" placeholder="请输入券数量" class="max-w460"></el-input>
        </el-form-item>
        
        <!-- 添加：课时 -->
        <el-form-item label="课时" prop="class_hours">
          <el-input v-model="form.class_hours" placeholder="请输入课时" class="max-w460"></el-input>
        </el-form-item>
        
        <!-- 添加：类型 -->
        <el-form-item label="类型" prop="voucher_type_id">
          <el-select 
            v-model="form.voucher_type_id" 
            placeholder="请选择所属类型"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="dept in voucherTypeList"
              :key="dept.voucher_type_id"
              :label="dept.name"
              :value="dept.voucher_type_id"
            />
          </el-select>
        </el-form-item>
        
        <!-- 添加：所属组织 -->
        <el-form-item label="组织" prop="ma_company_id">
          <el-select 
            v-model="form.ma_company_id" 
            placeholder="请选择组织"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="dept in maCompanyList"
              :key="dept.ma_company_id"
              :label="dept.name"
              :value="dept.ma_company_id"
            />
          </el-select>
        </el-form-item>
        
        <!-- 添加：所属地区 -->
        <el-form-item label="所属地区">
          <el-select v-model="form.province_id" placeholder="省" @change="initCity">
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
          </el-select>
          <el-select v-if="form.province_id!=''" v-model="form.city_id" placeholder="市" @change="initRegion">
            <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[form.province_id]['city']"
              :key='index1'></el-option>
          </el-select>
          <el-select v-if="form.city_id!=''" v-model="form.region_id" placeholder="区">
            <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[form.province_id]['city'][form.city_id]['region']"
              :key='index2'></el-option>
          </el-select>
        </el-form-item>
        
        <!-- 添加：使用范围 -->
        <el-form-item prop="range" label="使用范围">
          <el-input 
            v-model="form.range" 
            type="textarea"
            :rows="4"
            placeholder="请输入使用范围内容，用英文逗号隔开，例如：'河北省-石家庄市,河北省-唐山市'"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
        </el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
      </Upload>
    </div>
  </el-dialog>

</template>

<script>
import AfuncApi from '@/api/afunc.js';
import VoucherApi from '@/api/voucher.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import select_region from '@/utils/select.region.js';

export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    draggable,
    Uediter
  },
  data() {
    return {
      maCompanyList: [],
      voucherTypeList: [],
      areaList: select_region,
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        unit_price: '',       // 单价金额
        unit_price_unit: '0', // 单价单位，默认元/人次
        denomination: '',     // 面额
        num: '',              // 数量
        class_hours: '',      // 课时
        voucher_type_id: '',  // 类型ID
        ma_company_id: '',        // 所属组织ID
        province_id: '',      // 省ID
        city_id: '',          // 市ID
        region_id: '',        // 区ID
        range: '',           // 使用范围
        code: 'custom',
        image: [],
        sort: 50,
        intro: "",
        bannar: []
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入券名称', trigger: 'blur' }],
        unit_price: [{ 
          required: true, 
          message: '请输入单价', 
          trigger: 'blur' 
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '请输入正确的金额格式（最多两位小数）',
          trigger: 'blur'
        }],
        denomination: [{ 
          required: true, 
          message: '请输入面额', 
          trigger: 'blur' 
        }],
        num: [{ 
          required: true, 
          message: '请输入数量', 
          trigger: 'blur' 
        }],
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.loadOrganization();
    this.loadType();
    this.getDetail();
  },
  props: ["open_add", "voucher_id"],
  methods: {
    /*初始化城市id*/
    initCity() {
      this.form.city_id = '';
      this.form.region_id = '';
    },

    /*初始化区id*/
    initRegion() {
      this.form.region_id = '';
    },

    /*加载类型列表*/
    async loadType() {
      try {
        const response = await AfuncApi.call({
          model: 'voucher_type',
          action: 'getList',
          page: 1,
          list_rows: 1000
        });
        
        if (!response) {
          this.voucherTypeList = [];
          return;
        }
        if (response.code === 1 && response.data.list) {
          this.voucherTypeList = response.data.list.data || [];
        } else {
          this.voucherTypeList = [];
        }
      } catch (error) {
        this.voucherTypeList = [];
      }
    },
    
    /*加载组织列表*/
    async loadOrganization() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_company',
          action: 'getList',
        });
        
        if (!response) {
          this.$message.warning('组织列表接口返回为空');
          this.maCompanyList = [];
          return;
        }
        
        if (response.code === 1 && response.data.list.data) {
          this.maCompanyList = response.data.list.data || [];
        } else {
          this.$message.warning('获取组织列表失败：' + (response.msg || '未知错误'));
          this.maCompanyList = [];
        }
      } catch (error) {
        console.error('加载组织列表失败:', error);
        this.$message.error('加载组织列表失败，请稍后重试');
        this.maCompanyList = [];
      }
    },

    chooseCategory() {
      this.iscategorya = true;
    },
    
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    
    cancelFunc() { // 取消
      this.dialogFormVisible("error")
    },
    
    /*获取详情*/
    getDetail() {
      let self = this;
      VoucherApi.detail({ voucher_id: self.voucher_id }, true).then(res => {
        self.form = res.data;
        self.ueditor.text = self.form.intro;
        self.isImg = true
        self.loading = false;
        
        // 处理可能为null的字段
        if (!self.form.bannar) {
          self.form.bannar = [];
        }
        if (!self.form.image) {
          self.form.image = [];
        }
        if (!self.form.unit_price_unit) {
          self.form.unit_price_unit = '0'; // 默认值
        }
      })
      .catch(error => {
        console.error('获取详情失败:', error);
      });
    },
    
    /*提交修改*/
    onSubmit() {
      let self = this;
      let form = self.form;

      form.voucher_id = self.voucher_id;
      form.intro = this.$refs.ue ? this.$refs.ue.getUEContent() : '';
      
      self.$refs.form.validate(valid => {
        if (valid) {
          // 验证单价单位是否选择
          if (!form.unit_price_unit) {
            self.$message.warning('请选择单价单位');
            return;
          }
          
          self.loading = true;
          VoucherApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    /*打开上传图片*/
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (this.code == 'album') {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }

      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if (code == 'album') {
        this.form.image.splice(index, 1);
      } else if (code == 'bannar') {
        this.form.bannar.splice(index, 1);
      }
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: '#ffffff';
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: '#409eff';
}

/* 新增样式：单价输入框和单位选择框的布局 */
.price-input-wrapper {
  display: flex;
  align-items: center;
}

.max-w300 {
  max-width: 300px;
}

.max-w460 {
  max-width: 460px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/voucher/index/part/edit.vue